export class Utility {
    static make = {
        button: (value, config) => {
            config.color = config.color ?? 0xcf202f
            config.hover = config.hover ?? 0xaf202f
            const padding = { x: 50, y: 10 }
            const text = config.scene.add.text(0, 0, value, {
                fontSize: "24px",
                fill: "#ffffff",
                stroke: "#ffffff",
                strokeThickness: 1,
                fontFamily: "museo-sans-rounded, sans-serif"
            }).setResolution(2)
            const w = text.width + padding.x * 2
            const h = text.height + padding.y * 2
            text.x = -w/2 + padding.x
            text.y = -h/2 + padding.y
            const panel = config.scene.add.graphics()
                .fillStyle(config.color)
                .fillRoundedRect(-w/2, -h/2, w, h, 10)
            const button = config.scene.add.container(config.x, config.y)
            button.setDepth(200).setSize(w, h)
                .setInteractive({ cursor: 'pointer' })
                .on("pointerover", () => panel.clear().fillStyle(config.hover).fillRoundedRect(-w / 2, -h / 2, w, h, 10))
                .on("pointerout", () => panel.clear().fillStyle(config.color).fillRoundedRect(-w / 2, -h / 2, w, h, 10))
            button.add([panel, text])
            return button
        },
        text: (scene, x, y, value, styles) => {
            styles = styles ?? { }
            return scene.add.text(x, y, value, {
                fill: "#ffffff",
                stroke: "#000000",
                strokeThickness: 1,
                fontFamily: "museo-sans-rounded, sans-serif",
                ...styles
            }).setResolution(3)
        },
        dialog: {
            message: (scene, ops) => {
                const center = {
                    x: scene.cameras.main.worldView.centerX,
                    y: scene.cameras.main.worldView.centerY
                }
                scene.physics.pause()
                const board = scene.add.container(center.x - 220 * ops.scale, center.y - 120 * ops.scale).setSize(440, 240).setScale(ops.scale).setDepth(500)
                board.add(scene.add.graphics().fillStyle(0x070b34, 1).fillRoundedRect(0, 0, board.width, board.height, 24))
                board.add(Utility.make.text(scene, board.width / 2, 40, ops.title, {fontSize: "28px", fill: "#ff0000", strokeThickness: 5}).setOrigin(.5).setResolution(2))
                board.add(Utility.make.text(scene, board.width / 2, 80, ops.message, {fontSize: "20px", lineSpacing: "1", align: "center", wordWrap: { width: 378, useAdvancedWrap: true }}).setOrigin(.5).setResolution(2))
                let yes = Utility.make.button("Proceed", {scene: scene, x: 220, y: 180}).setScale(.75)
                board.add([yes])
                yes.on('pointerdown', () => {
                    board.destroy()
                    ops.proceed && ops.proceed()
                })
            },
            confirmation: (scene, ops) => {
                const center = {
                    x: scene.cameras.main.worldView.centerX,
                    y: scene.cameras.main.worldView.centerY
                }
                scene.physics.pause()
                const board = scene.add.container(center.x - 220 * ops.scale, center.y - 120 * ops.scale).setSize(440, 240).setScale(ops.scale).setDepth(500)
                board.add(scene.add.graphics().fillStyle(0x070b34, 1).fillRoundedRect(0, 0, board.width, board.height, 24))
                board.add(Utility.make.text(scene, board.width / 2, 40, ops.title, {fontSize: "28px", fill: "#ff0000", strokeThickness: 5}).setOrigin(.5).setResolution(2))
                board.add(Utility.make.text(scene, 40, 80, ops.message, {fontSize: "20px", lineSpacing: "1", align: "center", wordWrap: { width: 378, useAdvancedWrap: true }}).setResolution(2))
                let yes = Utility.make.button("Proceed", {scene: scene, x: 140, y: 180}).setScale(.75)
                let cancel = Utility.make.button("Cancel", {scene: scene, x: 300, y: 180, color: 0xffa500, hover: 0xcca500}).setScale(.75)
                board.add([yes, cancel])
                yes.on('pointerdown', () => {
                    board.destroy()
                    ops.proceed && ops.proceed()
                })
                cancel.on('pointerdown', () => {
                    board.destroy()
                    scene.physics.resume()
                    ops.cancel && ops.cancel()
                })
            }
        }
    }
}
